import "./Roller.scss"

import React, { FC, ReactNode, useEffect } from "react"

const ROLLING_TIME = 5 * 1000

interface Props {
  children: ReactNode
}

const Roller: FC<Props> = ({ children }) => {
  useEffect(() => {
    const rollingTimer = setInterval(() => {
      const prevElement = document.querySelector(".roller .prev")
      const currentElement = document.querySelector(".roller .current")
      const nextElement = document.querySelector(".roller .next")

      prevElement?.classList.remove("prev")
      prevElement?.classList.add("next")

      currentElement?.classList.remove("current")
      currentElement?.classList.add("prev")

      nextElement?.classList.remove("next")
      nextElement?.classList.add("current")

      setTimeout(() => {
        currentElement?.classList.remove("prev")
        currentElement?.classList.add("next")
      }, 500)
    }, ROLLING_TIME)

    return () => {
      clearInterval(rollingTimer)
    }
  }, [])

  return <ul className="roller">{children}</ul>
}

export default Roller
